// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import AccountEditScreen from "../../../src/screens/accounts/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} AccountEditRouteProps */

/** @typedef {Record<string, never>} AccountEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<AccountEditRouteProps, AccountEditRouteState>}
 */
class AccountEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit account")}</ScreenTitle>
        <AccountEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<AccountEditRouteProps>} */
const AccountEditRouteComponent = memo(shapeComponent(AccountEditRoute))

export default AccountEditRouteComponent
